import { 
  GET_PULLOUT_ITEMS,
  GET_PULLOUT_DATA,
  LOAD_MORE_PULLOUT_DATA
} from '../actions/types';

const pullout_data = {
  pullOutItems: [],
  data: [],
  origData:[],
  dataCount:0,
  dataNext:null,
  dataPrevious:null,
  editModalOpen: false,
  previewModalOpen: false,
  item:[],
  currentProps:null,


};





// eslint-disable-next-line import/no-anonymous-default-export
export default (state = pullout_data, action) => {
  var dataArray;
  switch (action.type) {   
    case GET_PULLOUT_ITEMS:            
      return {  
        ...state,
        pullOutItems:action.payload   
      };


    case GET_PULLOUT_DATA:         
      var  newdata = action.payload.dataArray
      var  lastVisible = action.payload.lastVisible
      return {  
        origData:newdata,
        data: newdata,
        dataCount:newdata.length,
        lastVisible:lastVisible,
        currentProps:action.payload.currentProps
      };

    case LOAD_MORE_PULLOUT_DATA:         
      var  newdata = action.payload.dataArray
      var  lastVisible = action.payload.lastVisible
      return {  
        ...state,
        origData:newdata.concat(state.origData),
        data: newdata.concat(state.data),
        dataCount:newdata.concat(state.origData).length,
        lastVisible:lastVisible,
     
      };
   
    default:
      return state;
  }
};
